import { AdvancedFilterInputSchema } from "@redotech/redo-model/outbound-labels/fulfillment-group-summary-input";
import { ShippingClaimSchema } from "@redotech/redo-model/shipping-claims/shipping-claim";
import {
  OpensearchPaginationCursorSchema,
  PaginationCursorSchema,
} from "@redotech/redo-model/tables/table";
import * as z from "zod";

export const getMerchantShippingClaims = {
  name: "getMerchantShippingClaims" as const,
  input: AdvancedFilterInputSchema.extend({
    pageNumber: z.number(),
    pageSize: z.number(),
    paginationCursor: PaginationCursorSchema.nullish(),
    opensearchCursor: OpensearchPaginationCursorSchema.nullish(),
  }),
  output: z.object({
    claims: z.array(ShippingClaimSchema),
    paginationCursor: PaginationCursorSchema.nullish(),
    opensearchCursor: OpensearchPaginationCursorSchema.nullish(),
  }),
};
